import { Link } from "react-router-dom";
import { AppLayout } from "../layout/Header";
import AgentResponseNav from "./AgentResponseNav";
import ProgressBar from "../widgets/ProgressBar";
import { AGENT_RESPONSE_STEPS } from "../../js/utils/agentResponseOptions";
import { hasContent } from "../../js/utils/formatters";
import { toTitleCase } from "../../js/utils/titleCase";
import { useDesk } from "../../js/hooks/useDesk";

export default function AgentResponseLayout({
  response,
  title,
  lead,
  children,
  onBack,
  onContinue,
  continueLabel = "Save & continue",
}) {
  const desk = useDesk();
  const shell = desk.variant === "broker" ? "broker" : "agent";
  const filled = AGENT_RESPONSE_STEPS.filter((step) => hasContent(response?.[step.key])).length;
  const percent = Math.round((filled / AGENT_RESPONSE_STEPS.length) * 100);
  const property = response?.property || {};
  const headline = [property.address, property.city].filter(Boolean).join(", ") || "Property response";

  return (
    <AppLayout variant={shell}>
      <p>
        <Link to={desk.responses}>← All property responses</Link>
      </p>
      <div className="page-header">
        <div>
          <p className="eyebrow">Agent Response System</p>
          <h1 className="section-title">{toTitleCase(title)}</h1>
          {lead ? <p className="page-lead">{lead}</p> : null}
          <p className="muted">{headline}</p>
        </div>
        <div style={{ minWidth: "180px" }}>
          <ProgressBar percent={percent} label="Response progress" />
        </div>
      </div>
      {response?.id ? <AgentResponseNav responseId={response.id} /> : null}
      <div className="card agent-response-card">{children}</div>
      <div className="wizard-actions">
        <button type="button" className="secondary-btn" onClick={onBack}>
          Back
        </button>
        <button type="button" className="primary-btn" onClick={onContinue}>
          {continueLabel}
        </button>
      </div>
    </AppLayout>
  );
}
